import React from 'react';
import PropTypes from 'prop-types';
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  UncontrolledTooltip,
} from 'reactstrap';
import classnames from 'classnames';
import { useIntl } from 'react-intl';

const ViewMode = ({
  view,
  setView,
  allowedViews,
  size,
}) => {
  const intl = useIntl();

  return (
    <UncontrolledDropdown>
      <DropdownToggle
        id="ViewModeDropdownButton"
        className="transparent-button"
        {...(size ? { size } : {})}
        aria-label={intl.formatMessage({ defaultMessage: 'View' })}
      >
        <i
          className={classnames('fal', {
            'fa-grid': view === 'grid',
            'fa-frame': view === 'framed',
            'fa-objects-column': view === 'masonry',
            'fa-list': view === 'list',
            'fa-objects-column fa-rotate-90': view === 'tile',
            'fa-gallery-thumbnails': view === 'slider',
          })}
        />
      </DropdownToggle>
      <UncontrolledTooltip target="ViewModeDropdownButton" fade={false} placement="top" boundariesElement="body">
        {intl.formatMessage({ defaultMessage: 'View' })}
      </UncontrolledTooltip>
      <DropdownMenu>
        {allowedViews.includes('grid') && (
          <DropdownItem
            active={view === 'grid'}
            onClick={() => {
              setView('grid');
            }}
          >
            <i className="fal fa-grid" />
            {intl.formatMessage({ defaultMessage: 'Grid' })}
          </DropdownItem>
        )}
        {allowedViews.includes('framed') && (
          <DropdownItem
            active={view === 'framed'}
            onClick={() => {
              setView('framed');
            }}
          >
            <i className="fal fa-frame" />
            {intl.formatMessage({ defaultMessage: 'Framed' })}
          </DropdownItem>
        )}
        {allowedViews.includes('masonry') && (
          <DropdownItem
            active={view === 'masonry'}
            onClick={() => {
              setView('masonry');
            }}
          >
            <i className="fal fa-objects-column" />
            {intl.formatMessage({ defaultMessage: 'Masonry' })}
          </DropdownItem>
        )}
        {allowedViews.includes('tile') && (
          <DropdownItem
            active={view === 'tile'}
            onClick={() => {
              setView('tile');
            }}
          >
            <i className="fal fa-objects-column fa-rotate-90" />
            {intl.formatMessage({ defaultMessage: 'Tile' })}
          </DropdownItem>
        )}
        {allowedViews.includes('list') && (
          <DropdownItem
            active={view === 'list'}
            onClick={() => {
              setView('list');
            }}
          >
            <i className="fal fa-list" />
            {intl.formatMessage({ defaultMessage: 'List' })}
          </DropdownItem>
        )}
        {allowedViews.includes('slider') && (
          <DropdownItem
            active={view === 'slider'}
            onClick={() => {
              setView('slider');
            }}
          >
            <i className="fal fa-gallery-thumbnails" />
            {intl.formatMessage({ defaultMessage: 'Slider' })}
          </DropdownItem>
        )}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

ViewMode.propTypes = {
  view: PropTypes.string.isRequired,
  setView: PropTypes.func.isRequired,
  allowedViews: PropTypes.array,
  size: PropTypes.string,
};

ViewMode.defaultProps = {
  allowedViews: ['grid', 'framed', 'masonry', 'tile', 'list'],
  size: null,
};

export default ViewMode;
